import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2
      className="text-white uppercase mb-5 border-b border-yellow-400 pb-3"
      style={{
        fontFamily: "'BebasNeue-Book', sans-serif",
        fontSize: "clamp(24px, 2.5vw, 34px)",
        letterSpacing: "0.04em",
        lineHeight: "1.1"
      }}
    >
      {title}
    </h2>
    <div
      className="text-gray-300 space-y-4"
      style={{
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 300,
        fontSize: "0.97rem",
        lineHeight: "1.75",
        letterSpacing: "0.01em"
      }}
    >
      {children}
    </div>
  </section>
);

const PoliticaPrivacidade = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />

      <PageHeader
        title="POLÍTICA DE PRIVACIDADE"
        subtitle="Como recolhemos, tratamos e protegemos os seus dados pessoais."
        backgroundImage="https://images.unsplash.com/photo-1551808525-051dba0e3577?w=1920&q=80"
        overlayOpacity={0.7}
      />

      <article className="py-16 sm:py-20 md:py-24 bg-black" data-testid="privacidade-content">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">

          <p
            className="text-gray-400 mb-12"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
              fontSize: "0.97rem",
              lineHeight: "1.7"
            }}
          >
            A presente Política de Privacidade descreve a forma como o website do <strong className="text-white">ULTIMATE FIT — Estúdio de Treino</strong> recolhe, armazena, trata e protege os dados pessoais dos seus clientes e visitantes, bem como os dados que possam ser recolhidos para fins estatísticos e analíticos.
          </p>

          <p
            className="text-gray-300 mb-10"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
              fontSize: "0.97rem",
              lineHeight: "1.75"
            }}
          >
            O ULTIMATE FIT compromete-se a garantir a privacidade e a proteção dos dados pessoais dos seus clientes e visitantes, em estrito cumprimento da legislação em vigor. Reservamo-nos o direito de atualizar e alterar periodicamente esta Política, refletindo eventuais alterações ao tratamento de dados pessoais ou a evoluções legais. Aconselhamos a consulta regular desta página para tomar conhecimento da versão mais atual.
          </p>

          <Section title="1 — Princípios orientadores">
            <p>
              O propósito desta Política é reforçar a relação de confiança entre o ULTIMATE FIT e os seus clientes, demonstrando transparência total no tratamento dos dados recolhidos e informando os titulares dos seus direitos e da forma como os podem exercer.
            </p>
          </Section>

          <Section title="2 — Base legal">
            <p>
              O ULTIMATE FIT atua de acordo com os princípios descritos nesta Política, com o Regulamento (UE) 2016/679 — Regulamento Geral sobre a Proteção de Dados (RGPD) — e com a restante legislação portuguesa de proteção de dados aplicável a todos os processos que envolvam o tratamento de dados pessoais.
            </p>
            <p>
              Para efeitos do RGPD, consideram-se "dados pessoais" quaisquer informações relativas a uma pessoa singular identificada ou identificável, direta ou indiretamente, nomeadamente por referência a um nome, número de identificação, dados de localização, identificadores online ou outros elementos específicos da identidade física, fisiológica, genética, mental, económica, cultural ou social dessa pessoa.
            </p>
          </Section>

          <Section title="3 — Responsável pelo tratamento">
            <p>
              O responsável pelo tratamento dos dados pessoais é o <strong className="text-white">ULTIMATE FIT — Estúdio de Treino</strong>, com sede na Rua Monsenhor Miguel de Oliveira 1366, 1.º andar, 3880-796 Ovar, contactável pelo e-mail <a href="mailto:geral@ultimatefit.pt" className="text-yellow-400 hover:underline">geral@ultimatefit.pt</a>.
            </p>
          </Section>

          <Section title="4 — Proteção dos dados">
            <p>
              Aplicamos medidas técnicas e organizativas adequadas para garantir a segurança da informação recolhida e a proteção dos dados pessoais, prevenindo a sua utilização indevida, alteração, acesso não autorizado, divulgação, perda ou destruição.
            </p>
            <p>
              Como titular dos seus dados, tem o direito a conhecer quais os dados recolhidos e armazenados, bem como a solicitar a sua retificação, exportação ou eliminação a qualquer momento.
            </p>
          </Section>

          <Section title="5 — Dados que são recolhidos">
            <p><strong className="text-white">Formulário de contacto e marcação de avaliação física</strong></p>
            <p>
              Quando o utilizador preenche um formulário no website, são recolhidos dados pessoais como nome, e-mail, telefone e outras informações fornecidas voluntariamente, com o objetivo de responder ao pedido e prestar os serviços solicitados.
            </p>
            <p><strong className="text-white">Newsletter</strong></p>
            <p>
              Quando o utilizador subscreve a newsletter, é recolhido o respetivo endereço de e-mail, mediante consentimento explícito.
            </p>
            <p><strong className="text-white">Navegação no website</strong></p>
            <p>
              São recolhidos dados técnicos relacionados com a navegação, como endereço IP, tipo de dispositivo, navegador, páginas visitadas e duração da visita, com fins estatísticos e de melhoria do desempenho do website.
            </p>
          </Section>

          <Section title="6 — Finalidades do tratamento">
            <p>Os dados pessoais são recolhidos e tratados para as seguintes finalidades:</p>
                        <ul className="list-disc pl-6 space-y-2">
              <li>Resposta a pedidos de contacto;</li>
              <li>Marcação de avaliações físicas, treinos e aulas;</li>
              <li>Gestão da relação com potenciais clientes;</li>
              <li>Envio de comunicações informativas e promocionais (newsletter), mediante consentimento prévio;</li>
              <li>Análise estatística e melhoria da experiência de navegação no website.</li>
            </ul>
            <p><strong className="text-white">Marketing direto (com o seu consentimento)</strong></p>
            <p>
              Mediante consentimento prévio, podemos enviar comunicações comerciais por e-mail ou SMS sobre novidades, ofertas, campanhas, eventos ou outros conteúdos do ULTIMATE FIT. O utilizador poderá retirar o seu consentimento a qualquer momento, através do link presente nas comunicações ou enviando um e-mail para <a href="mailto:geral@ultimatefit.pt" className="text-yellow-400 hover:underline">geral@ultimatefit.pt</a>.
            </p>
            <p>
              Em qualquer caso, o ULTIMATE FIT garante que a recolha e utilização dos dados é adequada às finalidades descritas e não constitui invasão da privacidade do cliente.
            </p>
          </Section>

          <Section title="7 — Quando recolhemos os dados">
            <p>
              Os dados são recolhidos quando o utilizador efetua o registo enquanto cliente, preenche um formulário de contacto, marca uma avaliação física, subscreve a newsletter ou navega no website.
            </p>
          </Section>

          <Section title="8 — Direitos do titular dos dados">
            <p>Enquanto titular de dados pessoais, dispõe a qualquer momento dos seguintes direitos:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Direito de acesso aos seus dados pessoais;</li>
              <li>Direito de retificação de dados incorretos ou desatualizados;</li>
              <li>Direito de oposição ao tratamento;</li>
              <li>Direito ao apagamento ("direito a ser esquecido");</li>
              <li>Direito à limitação do tratamento;</li>
              <li>Direito à portabilidade dos dados;</li>
              <li>Direito de não ficar sujeito a decisões individuais automatizadas;</li>
              <li>Direito de retirar o consentimento a qualquer momento, sem comprometer a licitude dos tratamentos efetuados anteriormente.</li>
            </ul>
            <p>
              Para exercer qualquer destes direitos, deverá enviar um pedido por e-mail para <a href="mailto:geral@ultimatefit.pt" className="text-yellow-400 hover:underline">geral@ultimatefit.pt</a>.
            </p>
            <p>
              Tem ainda o direito de apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD), em <a href="https://www.cnpd.pt/" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:underline">www.cnpd.pt</a>.
            </p>
          </Section>

          <Section title="9 — Retenção dos dados">
            <p>
              O ULTIMATE FIT está obrigado a reter determinada informação para cumprimento de obrigações fiscais e contabilísticas, bem como para auditorias, nos termos da lei em vigor (em regra, dez anos).
            </p>
            <p>
              Os restantes dados serão conservados pelo período em que o cliente mantiver a relação ativa com o ULTIMATE FIT, ou até que o titular solicite a sua eliminação. Os dados destinados a marketing serão conservados enquanto o consentimento se mantiver ativo.
            </p>
            <p>
              O titular pode, a qualquer momento, solicitar o acesso, a retificação ou a eliminação dos seus dados pessoais através do e-mail <a href="mailto:geral@ultimatefit.pt" className="text-yellow-400 hover:underline">geral@ultimatefit.pt</a>.
            </p>
          </Section>

          <Section title="10 — Partilha dos dados">
            <p>
              O ULTIMATE FIT não cede, vende nem transmite dados pessoais a terceiros, com exceção dos casos estritamente necessários ao funcionamento dos serviços (como prestadores de serviços de pagamento, alojamento web, envio de e-mail, contabilidade ou seguros), sempre com base em contratos de tratamento de dados que asseguram o cumprimento do RGPD.
            </p>
            <p>
              Os dados pessoais não serão utilizados para qualquer outra finalidade sem o devido consentimento do titular.
            </p>
            <p>
              Em circunstâncias especiais, o ULTIMATE FIT poderá divulgar informação pessoal identificável quando seja exigido pela lei ou por ordem judicial, ou ainda quando seja necessário para investigar violações dos Termos e Condições do serviço.
            </p>
          </Section>

          <Section title="11 — Cookies">
            <p>
              O website do ULTIMATE FIT utiliza cookies para melhorar a experiência de navegação, analisar o tráfego do website e compreender o comportamento dos utilizadores.
            </p>
            <p>Os cookies utilizados podem ser classificados como:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-white">Necessários:</strong> essenciais para o funcionamento do website;</li>
              <li><strong className="text-white">Analíticos:</strong> utilizados para recolher dados estatísticos sobre a utilização do website, nomeadamente através do Google Analytics;</li>
              <li><strong className="text-white">Marketing:</strong> utilizados apenas mediante consentimento, para envio de comunicações relevantes.</li>
            </ul>
            <p>
              Os cookies analíticos e de marketing apenas são ativados após o consentimento do utilizador, através do banner de cookies apresentado no acesso ao website.
            </p>
          </Section>

          <Section title="12 — Transferências internacionais de dados">
            <p>
              Sempre que existam transferências de dados pessoais para fora do Espaço Económico Europeu, o ULTIMATE FIT garante a aplicação das salvaguardas legais previstas no RGPD, incluindo cláusulas contratuais-tipo aprovadas pela Comissão Europeia ou outros mecanismos equivalentes.
            </p>
          </Section>

          <Section title="13 — Alterações à Política de Privacidade">
            <p>
              O ULTIMATE FIT poderá atualizar esta Política sempre que se revele necessário. As alterações serão divulgadas no website, sendo aconselhada a sua consulta periódica. A versão mais recente prevalecerá sempre sobre quaisquer versões anteriores.
            </p>
          </Section>

          <Section title="14 — Contactos">
            <p>
              Para qualquer questão, dúvida ou exercício de direitos relativa a esta Política de Privacidade ou ao tratamento de dados pessoais, poderá contactar-nos:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-white">E-mail:</strong> <a href="mailto:geral@ultimatefit.pt" className="text-yellow-400 hover:underline">geral@ultimatefit.pt</a></li>
              <li><strong className="text-white">Morada:</strong> Rua Monsenhor Miguel de Oliveira 1366, 1.º andar, 3880-796 Ovar</li>
            </ul>
          </Section>

          <div className="pt-8 mt-12 border-t border-gray-800">
            <p
              className="text-gray-400 italic"
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 300,
                fontSize: "0.9rem"
              }}
            >
              ULTIMATE FIT — Estúdio de Treino · Última atualização: {new Date().getFullYear()}
            </p>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default PoliticaPrivacidade;
